export const textGradient = 
  'bg-gradient-to-r from-primary via-secondary to-primary text-transparent bg-clip-text bg-[length:200%_auto] animate-gradient';

export const backgroundGradient = 
  'bg-gradient-to-b from-dark-lighter to-dark';